export const geoApiOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "91266b1a30msh2861c71bedc5fbbp12c05fjsn137c5de120d6",
    //"X-RapidAPI-Key": process.env.X_RAPID_API_KEY,
    "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
  },
};

export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";
export const CURRENT_WEATHER_API_URL =
  "https://api.openweathermap.org/data/2.5";
//export const CURRENT_WEATHER_API_KEY = process.env.CURRENT_WEATHER_API_KEY;
export const CURRENT_WEATHER_API_KEY = "8ab1388cbe68509d738a6fe8fe99df63";
//https://api.openweathermap.org/data/2.5/weather?lat={lat}&lon={lon}&appid={API key}
//CurrentWeather API key = 8ab1388cbe68509d738a6fe8fe99df63
